import React from 'react'
import brower from 'src/helper/brower'
const createClass = require('create-react-class')
const ReactDOM = require('react-dom')

const appLink = {
  universalLink: 'https://www.thechatie.com',
  yyb: '',
  androidLink: {
    group: 'yayya://thechatie.com/room/join?gid=',
  },
  AppStore: 'https://apps.apple.com/us/app/chatie-live/id1602794143', //暂时没有ios，用安卓连接
  googlePlay: 'https://play.google.com/store/apps/details?id=com.chatie.cn',
  androidAPK: 'https://play.google.com/store/apps/details?id=com.chatie.cn', //还没有单独的apk安装包
  // apkURL: 'https://hoby-s3-de.s3.eu-central-1.amazonaws.com/apk/hoby.apk',
  apkURL: 'https://play.google.com/store/apps/details?id=com.chatie.cn',
  apkHW: 'https://play.google.com/store/apps/details?id=com.chatie.cn', //华为不需要单独的apk，整合h5支付和Google
  vocaAPK: 'https://play.google.com/store/apps/details?id=com.chatie.cn',
}

function linkToApp(map) {
  let { universalLink, AppStore, yyb, apk, protoAndroid, protoIOS, dl = true } = map
  if (!protoIOS) {
    protoIOS = protoAndroid
  }
  if (brower.isWeixin()) {
    // 如果是微信内，直接跳转，不调起
    console.log('微信内')
    if (brower.isIphone() && AppStore && dl) {
      window.location.href = AppStore // 在微信内ios跳转
      return
    }
    if (yyb && dl) {
      window.location.href = yyb // 在微信内安卓跳转
    }
  } else {
    // 如果是其他方式，尝试调起
    console.log('微信外')
    if (brower.isIphone()) {
      console.log('ios Safari', protoIOS)

      if (universalLink) {
        // if (dl && brower.isQQ()) {
        //   window.location.href = appLink.yyb
        //   return
        // }
        if (dl) {
          window.location.href = universalLink
        } // 在其他浏览器ios跳转
        // 不知道为什么，这种iframe调起的模式不生效了，暂留
        // let jumpDiv = document.createElement('div')
        // document.body.appendChild(jumpDiv)
        // let Iframe1 = createClass({
        //   render: function() {
        //     return (
        //       <iframe id="iframe" src={protoIOS} frameborder="no" border="0"></iframe>
        //     )
        //   }
        // })
        // ReactDOM.render(<Iframe1 />, jumpDiv)

        // let jumpDiv = document.createElement('div')
        // document.body.appendChild(jumpDiv)
        // let Iframe1 = createClass({
        //   render: function() {
        //     return (
        //       <iframe id="iframe" src={universalLink} frameborder="no" border="0"></iframe>
        //     )
        //   }
        // })
        // ReactDOM.render(<Iframe1 />, jumpDiv)
      } else {
        if (protoIOS) {
          window.location.href = protoIOS
        } // 在其他浏览器ios跳转 备用schema
      }
      // 下载的逻辑需要在外面单独判断
    } else {
      console.log('安卓原生浏览器', protoAndroid)
      if (protoAndroid) {
        window.location.href = protoAndroid
      }
    }
  }
}

function iosDownload() {
  if (brower.isIphone()) {
    window.location.href = appLink.AppStore
  }
}

export default {
  linkToApp,
  iosDownload,
  appLink,
}



// WEBPACK FOOTER //
// src/helper/jumpToApp.js